import React, { useEffect } from 'react';
import FormLayout from '../components/FormLayout';
import FormHeader from '../components/FormHeader';
import { useNavigate } from 'react-router-dom';
const OPEN_COOKIE_PREFERENCES_EVENT = 'prairi:open-cookie-preferences';

const CookiesPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FormLayout maxWidthClass="max-w-4xl">
      <div className="mb-6">
        <button
          onClick={() => navigate(-1)}
          className="text-gray-400 hover:text-white transition-colors flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          Back
        </button>
      </div>

      <FormHeader title="Cookie Policy" subtitle="Last Updated: November 20, 2024" />

      <div className="max-w-none text-gray-300 mt-12 pb-12 space-y-8">
        <section>
          <h2 className="text-xl font-semibold text-white mb-3">What are cookies?</h2>
          <p>
            Cookies are small text files stored on your device when you visit a website. They help
            us remember your preferences and understand how you use our platform.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">The cookies we use</h2>
          <div className="space-y-4">
            <div className="bg-gray-800 rounded-lg p-4">
              <h3 className="font-medium text-white mb-1">Necessary cookies</h3>
              <p className="text-sm text-gray-400">
                Essential for the website to function. These cannot be disabled and do not require
                your consent.
              </p>
            </div>
            <div className="bg-gray-800 rounded-lg p-4">
              <h3 className="font-medium text-white mb-1">Analytics cookies</h3>
              <p className="text-sm text-gray-400">
                Help us understand how visitors interact with our site so we can improve it. We use
                Google Analytics with IP anonymisation enabled.
              </p>
            </div>
            <div className="bg-gray-800 rounded-lg p-4">
              <h3 className="font-medium text-white mb-1">Marketing cookies</h3>
              <p className="text-sm text-gray-400">
                Used to deliver relevant advertisements and measure the effectiveness of our
                campaigns.
              </p>
            </div>
            <div className="bg-gray-800 rounded-lg p-4">
              <h3 className="font-medium text-white mb-1">Functionality cookies</h3>
              <p className="text-sm text-gray-400">
                Remember your preferences and settings to enhance your experience on return visits.
              </p>
            </div>
            <div className="bg-gray-800 rounded-lg p-4">
              <h3 className="font-medium text-white mb-1">Personalization cookies</h3>
              <p className="text-sm text-gray-400">
                Provide personalized content and features based on your interests and behaviour.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">Your choices</h2>
          <p className="mb-4">
            You can change your cookie preferences at any time. Only necessary cookies will be set
            if you decline optional categories.
          </p>
          <button
            onClick={() => window.dispatchEvent(new Event(OPEN_COOKIE_PREFERENCES_EVENT))}
            className="bg-emerald-700 hover:bg-emerald-800 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            Manage cookie preferences
          </button>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">Contact</h2>
          <p>
            Questions about our use of cookies? Contact us at{' '}
            <a href="mailto:privacy@prairi.com" className="text-emerald-400 hover:underline">
              privacy@prairi.com
            </a>
            .
          </p>
        </section>
      </div>
    </FormLayout>
  );
};

export default CookiesPage;
